import styled from 'styled-components'
import { useStudentProject } from 'querys/student-projects'
import { FaGithub } from 'react-icons/fa'
import Wrapper from 'common/wrapper'
import Image from 'next/legacy/image'
import { Typography } from 'common/typography'
import { ButtonOutline, SecondaryButton } from 'common/button'
import Stack from 'projects/stack'
import { FiExternalLink } from 'react-icons/fi'

const StudentProjectheroStyled = styled.section`
  margin-block-start: var(--headerBlockSize);
  margin-block-end: 80px;
  .student {
    display: flex;
    margin: 24px 0;
    align-items: center;
    gap: 8px;
    max-width: fit-content;
    &-photo-container {
      display: flex;
      align-items: center;
      justify-items: center;
      background: linear-gradient(51.32deg, #FA057C 0%, #0704FE 100%, rgba(196, 196, 196, 0) 100%);
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }
    &-photo {
      border-radius: 50%;
    }
    &-photo-container {
      transition: 0.3 ease transform;
    }
    &:hover .student-photo-container {
      transform: scale(1.1);
    }
  }
  .stack-container {
    margin-block-start: 16px;
    margin-block-end: 24px;
  }
  .btns-container {
    display: grid;
    gap: 16px;
    grid-template-columns: 1fr;
  }
  .desktop-thumbnail {
    display: none;
  }
  .project-description {
    margin: 16px 0;
  }
  @media(min-width: 1024px) {
    margin-block-start: 40px;
    .mobile-thumbnail {
      display: none;
    }
    .desktop-thumbnail {
      display: block;
    }
    .project-hero {
      display: flex;
      justify-content: space-between;
      gap: 16px;
    }
    .project-hero-content {
      max-inline-size: 500px;
    }
    .btns-container {
      grid-template-columns: 1fr 1fr;
    }
  }
`

function StudentProjecthero() {
  const { data, isLoading, isError } = useStudentProject()

  if (isLoading || isError) return null

  const { title, student: { username, full_name, photo }, description, github_url, thumbnail, cover_image, project_url, stack } = data

  return (
    <StudentProjectheroStyled>
      <div className="mobile-thumbnail">
        <Image layout="responsive" src={thumbnail} width={783} height={587} alt={`Thumbnail de ${title}`} />
      </div>
      <Wrapper maxWidth={1366}>
        <div className="project-hero">
          <div className="project-hero-content">
            <a className="student" data-cy="student-avatar" href={`/estudiante/${username}`} target="_blank" rel="noopener noreferrer">
              <div className="student-photo-container">
                <img width="40" height="40" src={photo} className="student-photo" alt={`Foto de perfil de ${full_name}`} />
              </div>
              <p>{full_name}</p>
            </a>
            <Typography small="headline4" large="headline3">
              {title}
            </Typography>
            <p className="project-description">{description}</p>
            <div className="stack-container">
              <Stack stack={stack} />
            </div>
            <div className="btns-container">
              <SecondaryButton as="a" href={github_url} target="_blank" rel="noopener noreferrer" fullWidth>
                <FaGithub size="20px" color="white" />
                Ver codigo
              </SecondaryButton>
              <ButtonOutline as="a" href={project_url} target="_blank" rel="noopener noreferrer" fullWidth>
                <FiExternalLink size="20px" color="white" />
                Ver en la web
              </ButtonOutline>
            </div>
          </div>
          <div className="desktop-thumbnail">
            <Image src={cover_image} width={783} height={587} alt={`Thumbnail de ${title}`} />
          </div>
        </div>
      </Wrapper>
    </StudentProjectheroStyled>
  )
}

export default StudentProjecthero
